(function () {
    'use strict';

    // @ngInject
    function ZoomRedirectControllerCtor($scope, $injector, $location, $log, $q, $state, InitialAppLoadParamsService, AnalyticsService, AppStates, UsersManager, PopupMessageService, Enums, $window) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'ZoomRedirectController';
        AnalyticsService.trackPageView(this, 'ZoomRedirectView');
        this.$log = $log;
        this.$q = $q;
        this.$state = $state;
        this.AppStates = AppStates;
        this.UsersManager = UsersManager;
        this.user = this.UsersManager.getCurrUser();
        this.PopupMessageService = PopupMessageService;
        this.AnalyticsService = AnalyticsService;
        this.$window = $window;

        this.Enums = Enums;

        var queryStringParams = InitialAppLoadParamsService.getAllLoadParams();
        InitialAppLoadParamsService.cleanParamsFromView(['code', 'state']);
        var stateAsObject = JSON.parse(queryStringParams.state);
        var isReact = !!stateAsObject.is_react;

        if (isReact) {
            // Build URL with all query parameters
            var baseUrl = "https://app.honeybook.com/app/zoomOAuth2Callback";
            var queryParams = [];

            // Add all query parameters from the original request
            for (var key in queryStringParams) {
                if (queryStringParams.hasOwnProperty(key) && queryStringParams[key] !== null && queryStringParams[key] !== undefined) {
                    queryParams.push(encodeURIComponent(key) + '=' + encodeURIComponent(queryStringParams[key]));
                }
            }

            var redirectUrl = baseUrl;
            if (queryParams.length > 0) {
                redirectUrl += '?' + queryParams.join('&');
            }

            this.redirectTo(redirectUrl);
            return;
        }

        if (queryStringParams.code, stateAsObject.validation_code) {
            this.UsersManager.setZoomAuthCode(queryStringParams.code, stateAsObject.validation_code)
                .then(function success() {
                    this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.save_zoom_integration_auth_code);

                    if (stateAsObject.return_url) {
                        this.$window.location.href = stateAsObject.return_url;
                    } else {
                        this.goToState(this.AppStates.root_core_navigation_calendar);
                    }

                }.bind(this))
                .catch(function fail(resp) {
                    this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.save_zoom_integration_auth_code, resp);

                    if (resp && resp.data && resp.data.error_type && resp.data.error_message && resp.data.error_type === "HBUserError") {

                        this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, resp.data.error_message, function success() {
                            this.redirectTo(queryStringParams.state);
                        }.bind(this));
                    }
                    else {
                        this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, 'ERRORS.SERVER_API._TRY_AGAIN_', function success() {
                            this.redirectTo(queryStringParams.state);
                        }.bind(this));
                    }
                    this.$log.error('failed to save the auth-code on the zoom integration model');
                }.bind(this));

        } else if (queryStringParams.error) {
            this.$log.error('Error in zoom authentication process: ' + $location.url());
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.zoom_integration_error);
            this.goToState(this.AppStates.root_core_navigation_settings_company_integrations);
        }
    }

    Controllers.ZoomRedirectController = Class(Controllers.BaseController, {
        constructor: ZoomRedirectControllerCtor,

        redirectTo: function redirectTo(state) {
            if (state) {
                this.$window.location.href = state;
            } else {
                this.goToState(this.AppStates.root_core_navigation_calendar);
            }

        }
    });
}());

Function.ubind = function (self) {
    var f = this;
    return function () {
        f.apply(self, Array.prototype.slice.call(arguments, 0));
    };
};
